export const ASSISTANCE_REQUEST = {
  created: 'AR - Submitted',
};

const eventConstants = {
  ASSISTANCE_REQUEST,
};

export default eventConstants;
